"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var sizeControlHeight = _a.sizeControlHeight;
  return {
    base: {
      display: 'block',
      cursor: 'pointer',
      height: sizeControlHeight,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      textDecoration: 'none'
    },
    google: {
      width: 135 / 40 * sizeControlHeight,
      backgroundImage: 'url("https://img.imgsmail.ru/static.promo/announcement/promo/google-play.svg")'
    },
    apple: {
      width: 135 / 40 * sizeControlHeight,
      backgroundImage: 'url("https://img.imgsmail.ru/static.promo/announcement/promo/app-store.svg")'
    }
  };
};